import { ActionTypes } from 'utils/constants';
import { pushConversion } from 'utils/push-conversion';

// Forwards the Lead conversion's event name + id from the account-creation
// response into the dataLayer, so the browser-side Meta tag can send the same
// pair and be deduplicated against the Conversions API event the server already
// sent. See utils/push-conversion.js.
//
// The other two conversions (InitiateCheckout, Subscribe/StartTrial) are pushed
// from the components that make those requests.
export const conversionMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === ActionTypes.CREATE_ACCOUNT + '_FULFILLED') {
        pushConversion(action?.payload?.data?.conversion);
    }

    return result;
};
